<script>
import {required} from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Unit from "@/components/modals/unit.vue";
import MaskedInput from "vue-text-mask";
export default {
    name: 'PoItemUpdate',
    components: {
        Unit,
        MaskedInput
    },
    props: {
        modalTitle: {
            type: String,
            default: "Purchase Order Item Update"
        },
    },
    data() {
        return {
            form: {
                rfqSupplierId: null,
                rfqItemId: null,
                itemName: "",
                description: "",
                brand: "",
                model: "",
                specification: "",
                color: "",
                dimensionDescription: "",
                materialUsed: "",
                packageDescription: "",
                condition: "",
                unitId: "",
                unitName: "",
                quantity: "",
                unitCost: "",
                deliveryPeriod: "",
                note: ""
            },
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true
            }),
            loading: false,
        };
    },
    validations: {
        form: {
            itemName: {required},
            description: {required},
            condition: {required},
            unitId: {required},
            quantity: {required},
            unitCost: {required}
        }
    },
    methods: {
        onUpdate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            data.unitCost = this.getExactAmt(data.unitCost);
            this.$emit("update-item", data);
        },
        resetForm() {
            this.form = {
                rfqSupplierId: null,
                rfqItemId: null,
                itemName: "",
                description: "",
                brand: "",
                model: "",
                specification: "",
                color: "",
                dimensionDescription: "",
                materialUsed: "",
                packageDescription: "",
                condition: "",
                unitId: "",
                unitName: "",
                quantity: "",
                unitCost: "",
                deliveryPeriod: "",
                note: ""
            };
            this.submitted = false;
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.form.unitName = data.unitName;
            this.form.unitId = data.id;
        },
        async getData(item){
            this.loading = true;
            await this.$store
                .dispatch("rfqsupplieroffer/GetSingleRSO", item.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.form = {
                        id: res.data.id,
                        rfqSupplierId: res.data.rfqSupplierId,
                        rfqItemId: res.data.rfqItemId,
                        itemName: res.data.itemName,
                        description: res.data.description,
                        brand: res.data.brand,
                        model: res.data.model,
                        specification: res.data.specification,
                        color: res.data.color,
                        dimensionDescription: res.data.dimensionDescription,
                        materialUsed: res.data.materialUsed,
                        packageDescription: res.data.packageDescription,
                        condition: res.data.condition || "New",
                        unitId: res.data.unitId,
                        unitName: item.unit,
                        quantity: res.data.quantity.toString(),
                        unitCost: res.data.unitCost.toString(),
                        deliveryPeriod: "",
                        note: res.data.note
                    }
                }).catch((err) => {
                    this.showToast("An error occurred while fetching data.", "error");
                });
            this.loading = false;
        }
    }
}
</script>
<template>
    <b-modal 
        id="modal-update-item" 
        :title="modalTitle" 
        size="xl" 
        title-class="font-18" 
        hide-footer
        no-close-on-backdrop
    >
        <div class="mb-3">
            <form @submit.prevent="onUpdate" class="needs-validation" ref="fcForm">
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="itemName">Item Name </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <input 
                                id="itemName" 
                                type="text" 
                                v-model="form.itemName" 
                                placeholder="Enter Item Name..."
                                class="form-control" 
                                :class="{'is-invalid': submitted && $v.form.itemName.$error}" 
                                autocomplete="off" 
                                v-else
                            />
                            <div v-if="submitted && $v.form.itemName.$error" class="invalid-feedback">
                            <span>This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="unitCost">Unit Cost </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <masked-input 
                                id="unitCost" type="text" v-model="form.unitCost" placeholder="Enter Unit Cost..."
                                class="form-control" 
                                :class="{'is-invalid': submitted && $v.form.unitCost.$error}" 
                                autocomplete="off" 
                                :mask="currencyMask"
                                v-else
                            ></masked-input>
                            <div v-if="submitted && $v.form.unitCost.$error" class="invalid-feedback">
                            <span>This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="condition">Condition </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <b-form-select 
                                class="form-select" 
                                :class="{'is-invalid': submitted && $v.form.condition.$error }" 
                                v-model="form.condition"
                                v-else
                            >
                                <b-form-select-option value="" disabled>Select Condition...</b-form-select-option>
                                <b-form-select-option value="New">New</b-form-select-option>
                                <b-form-select-option value="Purchased">Purchased</b-form-select-option>
                                <b-form-select-option value="Used">Used</b-form-select-option>
                                <b-form-select-option value="Donated">Donated</b-form-select-option>
                                <b-form-select-option value="Refurbished">Refurbished</b-form-select-option>
                                <b-form-select-option value="Re-condition">Re-condition</b-form-select-option>
                            </b-form-select>
                            <div v-if="submitted && $v.form.condition.$error" class="invalid-feedback">
                                <span>This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="brand">Brand </label>
                            
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <input 
                                id="brand" 
                                type="text" 
                                v-model="form.brand" 
                                placeholder="Enter Brand..." 
                                class="form-control"
                                autocomplete="off" 
                                v-else 
                            />
                        </div>
                        <div class="mb-3">
                            <label for="dimensionDescription">Dimension Description</label>
                            <b-skeleton width="100%" height="90px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <textarea 
                                id="dimensionDescription" 
                                rows="3" 
                                v-model="form.dimensionDescription"
                                placeholder="Enter Dimension Description..." 
                                class="form-control" 
                                autocomplete="off"
                                v-else
                            ></textarea>
                        </div>
                        <div class="mb-3">
                            <label for="packageDescription">Package Description</label>
                            <b-skeleton width="100%" height="90px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <textarea 
                                id="packageDescription" 
                                rows="3" 
                                v-model="form.packageDescription"
                                placeholder="Enter Package Description..." 
                                class="form-control" 
                                autocomplete="off"
                                v-else
                            ></textarea>
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="description">Description </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <input 
                                id="description" 
                                type="text" 
                                v-model="form.description" 
                                placeholder="Enter Description..."
                                class="form-control" 
                                :class="{'is-invalid': submitted && $v.form.description.$error}" 
                                autocomplete="off" 
                                v-else
                            />
                            <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
                                <span>This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="unit">Unit </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <b-input-group v-else>
                                <template #append>
                                    <b-button 
                                        @click="getUnit()" 
                                        variant="outline-info"><i
                                        class="mdi mdi-clipboard-text-search-outline"></i>
                                    </b-button>
                                </template>
                                <input 
                                    autocomplete="off" 
                                    type="text" disabled 
                                    placeholder="Search Unit..." 
                                    class="form-control"
                                    :class="{'is-invalid': submitted && $v.form.unitId.$error}" 
                                    v-model="form.unitName" 
                                />
                            </b-input-group>
                            <div v-if="submitted && $v.form.unitId.$error" class="invalid-feedback">
                                <span>This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="brand">Model </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <input 
                                id="model" 
                                type="text" 
                                v-model="form.model" 
                                placeholder="Enter Model..." 
                                class="form-control"
                                autocomplete="off" 
                                v-else
                            />
                        </div>
                        <div class="mb-3">
                            <label for="color">Color </label>
                            <b-skeleton width="100%" height="35px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <input 
                                id="color" 
                                type="text" 
                                v-model="form.color" 
                                placeholder="Enter Property Color..."
                                class="form-control" 
                                autocomplete="off"
                                v-else
                            />
                        </div>
                        <div class="mb-3">
                            <label for="specification">Specification </label>
                            <b-skeleton width="100%" height="90px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <textarea 
                                id="specification" 
                                rows="3" 
                                v-model="form.specification"
                                placeholder="Enter Specification..." 
                                class="form-control" 
                                autocomplete="off"
                                v-else
                            >
                            </textarea>
                        </div>
                        <div class="mb-3">
                            <label for="materialUsed">Material Used</label>
                            <b-skeleton width="100%" height="90px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>
                            <textarea 
                                id="materialUsed" 
                                rows="3" 
                                v-model="form.materialUsed"
                                placeholder="Enter Material Used..." 
                                class="form-control" 
                                autocomplete="off"
                                v-else
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="note">Notes</label>
                    <b-skeleton width="100%" height="90px" class="bg-primary bg-soft" v-if="loading"></b-skeleton>  
                    <textarea 
                        id="note" 
                        rows="3" 
                        v-model="form.note" 
                        placeholder="Enter Notes..."
                        class="form-control" 
                        autocomplete="off"
                        v-else
                    ></textarea>
                </div>
                <div class="d-flex flex-row-reverse mb-3" v-if="!loading">
                    <button class="btn btn-primary mt-3" type="submit">Update</button>
                </div>
            </form>
        </div>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
    </b-modal>
</template>